import { DecimalPipe } from '@angular/common';
import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'customNumber',
  standalone: true,
})
export class CustomDecimalPipe extends DecimalPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (Number.isInteger(value)) return value;

    return super.transform(value, args);
  }
}
